/**
 * Aviso que se apaga sozinho ("Salvo na prévia", "Arquivado na prévia").
 *
 * Guarda o TEXTO do aviso, e nao um booleano, porque a mesma faixa anuncia
 * acoes diferentes (criar, editar, duplicar, arquivar, restaurar) e o leitor
 * de tela precisa ouvir qual foi. Avisar de novo antes do prazo reinicia o
 * relogio.
 *
 * `desfazer` e opcional: arquivar e restaurar versao sao reversiveis, e o
 * botao "Desfazer" ao lado do aviso e mais barato que um modal de
 * confirmacao (e nao interrompe quem esta arquivando dez modelos seguidos).
 * Com acao, o aviso fica mais tempo na tela.
 */

import { useCallback, useEffect, useState } from 'react';

const VISIVEL_MS = 2_400;
const VISIVEL_COM_ACAO_MS = 6_000;

export interface Aviso {
  readonly texto: string;
  readonly desfazer?: () => void;
}

export function useAviso(): readonly [Aviso | null, (texto: string, desfazer?: () => void) => void, () => void] {
  const [aviso, setAviso] = useState<Aviso | null>(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (aviso === null) {
      return undefined;
    }
    const timer = window.setTimeout(() => setAviso(null), aviso.desfazer === undefined ? VISIVEL_MS : VISIVEL_COM_ACAO_MS);
    return () => window.clearTimeout(timer);
  }, [aviso, tick]);

  const avisar = useCallback((texto: string, desfazer?: () => void): void => {
    setAviso(desfazer === undefined ? { texto } : { texto, desfazer });
    setTick((n) => n + 1);
  }, []);

  const limpar = useCallback((): void => setAviso(null), []);

  return [aviso, avisar, limpar];
}
